/**
 * FGA relation constants
 *
 * Keep in sync with admin_middleware/src/admin_middleware/services/fga/authorization.py
 */

export type FgaRelation = 'member' | 'developer' | 'admin';

// Base selectable roles (always visible). `member` is appended at runtime when
// the `showMemberRole` feature flag is on — see `selectableRolesForFlag()`.
export type SelectableFgaRelation = FgaRelation;
export const SELECTABLE_FGA_RELATIONS: SelectableFgaRelation[] = [ 'admin', 'developer' ];

export function selectableRolesForFlag( showMemberRole: boolean ): SelectableFgaRelation[] {
  return showMemberRole ? [ ...SELECTABLE_FGA_RELATIONS, 'member' ] : SELECTABLE_FGA_RELATIONS;
}

// auth0 roles to fga. godmode collapses to admin
export const ROLE_TO_FGA: Record<string, FgaRelation> = {
  godmode: 'admin',
  admin: 'admin'
};

// Inverse direction. `member` has no Auth0 role — FGA tuple is the only source of truth.
export const FGA_TO_AUTH0_ROLE: Record<SelectableFgaRelation, string | null> = {
  admin: 'admin',
  developer: null,
  member: null
};

